import { render, staticRenderFns } from "./radio-group.vue?vue&type=template&id=818a704c&"
import script from "./radio-group.vue?vue&type=script&lang=js&"
export * from "./radio-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('818a704c')) {
      api.createRecord('818a704c', component.options)
    } else {
      api.reload('818a704c', component.options)
    }
    module.hot.accept("./radio-group.vue?vue&type=template&id=818a704c&", function () {
      api.rerender('818a704c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/radio/src/radio-group.vue"
export default component.exports